var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"codeCont",style:({ bottom: _vm.bottom })},[_c('img',{staticClass:"codeCont-img",attrs:{"src":require(`../assets/imgs/${_vm.pic}/code.png`)}}),_c('span',{staticClass:"codeCont-font"},[_vm._v("扫二维码获取更多详情")])])
}
var staticRenderFns = []

export { render, staticRenderFns }